import { Link } from 'react-router-dom'

export default function CookieConsent({ consent, onAcceptAll, onNecessaryOnly }) {
  if (consent !== null) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-5">
      <div className="max-w-4xl mx-auto rounded-2xl border border-border/10 bg-surface/95 backdrop-blur-sm p-4 sm:p-5 shadow-2xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-heading text-sm font-semibold mb-1">Cookie-k és adatvédelem</p>
            <p className="text-subtle-text text-xs leading-relaxed">
              Elemzési cookie-kat (Google Analytics, Meta Pixel, Clarity) és munkamenet-cookie-kat használunk
              az oldal fejlesztéséhez. A „Csak szükségesek" opció esetén analytics nem tölt be.{' '}
              <Link to="/adatkezeles" className="text-gold hover:text-gold-light underline underline-offset-2 transition-colors">
                Adatkezelési tájékoztató →
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-2.5 flex-shrink-0 self-end sm:self-auto">
            <button
              onClick={onNecessaryOnly}
              className="text-xs px-4 py-2 rounded-full border border-border/15 text-muted-text hover:border-border/40 hover:text-heading transition-all"
            >
              Csak szükségesek
            </button>
            <button
              onClick={onAcceptAll}
              className="text-xs font-bold text-ink px-5 py-2.5 rounded-full transition-all hover:-translate-y-0.5 whitespace-nowrap"
              style={{ background: 'linear-gradient(90deg,#C9A84C,#F5EDD0)', boxShadow: '0 4px 16px rgba(201,168,76,0.25)' }}
            >
              Elfogadom →
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
